import type { HighLevelIssue } from '../types/content';
import { CategoryImage } from './CategoryImage';

interface CategoryHeroProps {
  issue: HighLevelIssue;
  meta?: string;
}

export function CategoryHero({ issue, meta }: CategoryHeroProps) {
  return (
    <header className="category-hero">
      <div className="category-hero-image-wrap">
        <CategoryImage issue={issue} className="category-hero-image" />
      </div>
      <div className="category-hero-content">
        <h1>{issue.title}</h1>
        <p className="category-hero-summary">{issue.voterFacingSummary}</p>
        {meta && <p className="section-count">{meta}</p>}
      </div>
    </header>
  );
}
